import React, { useEffect, useState } from 'react'

import { Box, Text } from '@chakra-ui/react'

import { StarSVG } from '@/assets/icons'

export const StarRating = ({
  ratingValue,
  setRatingValue,
  ratingTypeText,
  isDisabled,
  ...props
}: React.ComponentProps<typeof Box> & {
  ratingValue?: number | null
  setRatingValue: (reportQuality: number) => void
  ratingTypeText: string
  isDisabled?: boolean
}) => {
  const [hoverRating, setHoverRating] = useState(0)
  const starsCount = 5
  const [ratingLabel, setRatingLabel] = useState<string>('')

  useEffect(() => {
    switch (hoverRating) {
      case 0:
        setRatingLabel('')
        break
      case 1:
        setRatingLabel('very poor')
        break
      case 2:
        setRatingLabel('poor')
        break
      case 3:
        setRatingLabel('okay')
        break
      case 4:
        setRatingLabel('good')
        break
      case 5:
        setRatingLabel('excellent')
        break
    }
  }, [hoverRating])

  const getFillValue = (starNumber: number) => {
    if (hoverRating > 0) {
      if (hoverRating >= starNumber) {
        return 'black'
      }
      return '#D9D9D9'
    }

    if ((ratingValue || 0) >= starNumber) {
      return 'black'
    }

    return '#D9D9D9'
  }

  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      {...props}
      alignItems={'center'}
      opacity={isDisabled ? 0.5 : 1}
      pointerEvents={isDisabled ? 'none' : 'auto'}
      aria-disabled={isDisabled}
    >
      <Text fontWeight={'bold'} fontSize={'1rem'}>
        Quality of this {ratingTypeText}?
      </Text>
      <Box ml={2} display={'flex'} flexDirection={'row'}>
        {Array(starsCount)
          .fill(null)
          .map((_, index) => {
            const starNumber = index + 1
            return (
              <Box
                px={0.5}
                key={index}
                onMouseEnter={() => !isDisabled && setHoverRating(starNumber)}
                onMouseLeave={() => !isDisabled && setHoverRating(0)}
                onClick={() => !isDisabled && setRatingValue(starNumber)}
                style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
              >
                <StarSVG fill={getFillValue(starNumber)} />
              </Box>
            )
          })}
      </Box>
      <Text fontWeight={'bold'} ml={4} fontSize={'1rem'} color={'#7A7A7A'}>
        {ratingLabel}
      </Text>
    </Box>
  )
}
